import './AuthLeftPanel.css';
import whiteLogo from '../../../assets/images/SVG/whitecoloreduonelogo.svg';
import leftImage from '../../../assets/images/left-image-1.jpg';

const AuthLeftPanel = ({
    image = leftImage,
    termsText = (
        <>
            Your data and grading activities are protected under our
            <br />
            privacy and security standards.
        </>
    ),
}) => {
    // Get current year in Sri Lankan timezone
    const currentYear = new Date().toLocaleString('en-US', {
        timeZone: 'Asia/Colombo',
        year: 'numeric',
    });

    return (
        <div className="auth-left-panel">
            <img
                src={image}
                alt="Education illustration"
                className="auth-left-panel__image"
            />

            <div className="auth-left-panel__top-overlay">
                <img src={whiteLogo} alt="EduOne.LK" className="auth-left-panel__top-logo" />
                <p className="auth-left-panel__top-text">
                    A Next-Generation Student Learning Platform Built to Power<br />
                    Personalized Study, Adaptive Learning Workflows, and<br />
                    Data-Driven Academic Excellence
                </p>
            </div>

            <div className="auth-left-panel__bottom-overlay">
                <div className="auth-left-panel__overlay-content">
                    <div className="auth-left-panel__terms">
                        <p>{termsText}</p>
                    </div>
                    <div className="auth-left-panel__footer">
                        <div className="auth-left-panel__rights">All rights reserved © {currentYear}</div>
                        <div className="auth-left-panel__brand">FonixEdu {currentYear}</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AuthLeftPanel;
